module.exports = __webpack_public_path__ + "media/assets_v3/images/knight-online-cypher-ring-82780d0e62b752d2022770d5213af9ca.jpg";